import styled from 'styled-components/macro';

export const StyledHelperMessage = styled.p`
  display: block;
  font-family: 'Circular Std', sans-serif;
`;
